import type {IdentityCardDataRequestBody} from './IdentityCardDataRequestBody';

export type IdentityCardRequestBody = {
  id: string | null;
  cardData: IdentityCardDataRequestBody;
};
